export default {
    User: {
        firstName: null,
        lastName: null,
        Enable: false,
        email: null,
    },
    Edit: false
}